// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prev-next-button {
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgb(242, 252, 255);
  border-radius: 3px;
  border-style: solid;
  border-color: grey;
  border-width: 1px;
}

.prev-next-button.disabled {
  pointer-events: none;
  opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Quiz/PrevNextButton/PrevNextButton.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".prev-next-button {\n  padding: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  background-color: rgb(242, 252, 255);\n  border-radius: 3px;\n  border-style: solid;\n  border-color: grey;\n  border-width: 1px;\n}\n\n.prev-next-button.disabled {\n  pointer-events: none;\n  opacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
